import { createContext } from "react";
const StoreContext = createContext({
  token: "",
  usr_type: "",
  usr_id: "",
  usr_nombre: "",
  usr_sucursal: "",
  usr_print: "",
  com_suc_emisor: "",
  usr_company: "",
  usr_ajustes: "",
  dataFacturaDetallePr: [],
  usr_factura: "",
  usr_inventario: "",
  usr_cotizacion: "",
  usr_precio: "",
  usr_articulo: "",
  caja_n: "",
  compania: "",
  usr_reporte: "",
  usr_fac_compra: "",
  usr_movimiento: "",
  usr_hacer_inventario: "",
  usr_trazabilidad: "",
  usr_a_costo: "",
  usr_apartado: "",
  usr_gastos: "",
  dataCompania: [],
  cajaData: [],
  key: "",
  usr_clientes: "",
  usr_key_login: "",
  setdataFacturaLocalStorage: ({ dataFacturaDetallePr }) => {},
  setToken: ({
    token,
    usr_perfil,
    usr_modo_tableta,
    usr_id,
    usr_nombre,
    usr_sucursal,
    usr_print,
    com_suc_emisor,
    usr_company,
    usr_ajustes,
    usr_factura,
    usr_inventario,
    usr_cotizacion,
    usr_precio,
    usr_articulo,
    usr_reporte,
    usr_fac_compra,
    usr_movimiento,
    usr_hacer_inventario,
    usr_trazabilidad,
    usr_a_costo,
    usr_apartado,
    usr_gastos,
    dataCompania,
    cajaData,
    usr_clientes,
    caja_n,
    compania,
    usr_key_login,
  }) => {},
  quitToken: () => {},
}); // Create a context object

export default StoreContext;
